import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Type of NFT to mint: ")
const _hoisted_4 = { class: "text-gray-400 mt-2 flex justify-around" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Master Edition", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Standard Edition (Print)", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" (!) Minting Standard Editions requires 1) that you have the Master Edition in your wallet and 2) that the max supply cap isn't hit. Read more ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://docs.metaplex.com/about/terminology#master-edition",
  target: "_blank",
  class: "nes-text is-primary"
}, "here", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_10 = { class: "nes-field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "uri" }, "Arweave / IPFS URI:", -1)
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "nes-field mt-5" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "maxSupply" }, "Max Supply (leave blank for uncapped):")
], -1)
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "nes-field mt-5" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "masterEditionMint" }, "Master Edition Mint:")
], -1)
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = { class: "nes-field mt-5" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "updateAuthority" }, "Update Authority (leave blank for default):")
], -1)
const _hoisted_22 = ["placeholder"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, "Mint successful! 🎉", -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Loading your new NFT... (might take a min or two)")
const _hoisted_26 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestionMark = _resolveComponent("QuestionMark")!
  const _component_NotifyWarning = _resolveComponent("NotifyWarning")!
  const _component_StdNotifications = _resolveComponent("StdNotifications")!
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")!
  const _component_ExplorerLink = _resolveComponent("ExplorerLink")!
  const _component_NFTViewCard = _resolveComponent("NFTViewCard")!
  const _component_NotifySuccess = _resolveComponent("NotifySuccess")!
  const _component_ContentTooltipArweave = _resolveComponent("ContentTooltipArweave")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_QuestionMark, { external: "https://docs.metaplex.com/about/terminology#master-edition" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            class: "nes-radio",
            value: "master",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chosenNFTType) = $event))
          }, null, 512), [
            [_vModelRadio, _ctx.chosenNFTType]
          ]),
          _hoisted_5
        ]),
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            class: "nes-radio",
            value: "print",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.chosenNFTType) = $event))
          }, null, 512), [
            [_vModelRadio, _ctx.chosenNFTType]
          ]),
          _hoisted_6
        ])
      ])
    ]),
    (_ctx.chosenNFTType === 'print')
      ? (_openBlock(), _createBlock(_component_NotifyWarning, {
          key: 0,
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _hoisted_8,
            _hoisted_9
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.chosenNFTType === 'master')
      ? (_openBlock(), _createElementBlock("form", {
          key: 1,
          class: "mt-10",
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.mintNewMaster && _ctx.mintNewMaster(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _hoisted_11,
              _createVNode(_component_QuestionMark, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal('tooltipArweave')))
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "uri",
              class: "nes-input",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.uri) = $event)),
              placeholder: _ctx.DEFAULTS.URI
            }, null, 8, _hoisted_12), [
              [_vModelText, _ctx.uri]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              type: "number",
              id: "maxSupply",
              class: "nes-input",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.maxSupply) = $event)),
              placeholder: _ctx.DEFAULTS.MAX_SUPPLY
            }, null, 8, _hoisted_15), [
              [_vModelText, _ctx.maxSupply]
            ])
          ]),
          _createElementVNode("button", {
            class: _normalizeClass(["nes-btn is-primary mt-5", { 'is-disabled': _ctx.isLoading || !_ctx.isConnected }]),
            disabled: _ctx.isLoading || !_ctx.isConnected,
            type: "submit"
          }, " Mint new Master NFT ", 10, _hoisted_16)
        ], 32))
      : (_ctx.chosenNFTType === 'print')
        ? (_openBlock(), _createElementBlock("form", {
            key: 2,
            class: "mt-5",
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.mintNewPrint && _ctx.mintNewPrint(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "masterEditionMint",
                class: "nes-input",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.masterEditionMint) = $event)),
                placeholder: _ctx.DEFAULTS.MASTER_MINT
              }, null, 8, _hoisted_19), [
                [_vModelText, _ctx.masterEditionMint]
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "updateAuthority",
                class: "nes-input",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.updateAuthority) = $event)),
                placeholder: _ctx.DEFAULTS.UPDATE_AUTHORITY
              }, null, 8, _hoisted_22), [
                [_vModelText, _ctx.updateAuthority]
              ])
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["nes-btn is-primary mt-5", { 'is-disabled': _ctx.isLoading || !_ctx.isConnected }]),
              disabled: _ctx.isLoading || !_ctx.isConnected,
              type: "submit"
            }, " Mint new Print NFT ", 10, _hoisted_23)
          ], 32))
        : _createCommentVNode("", true),
    _createVNode(_component_StdNotifications, {
      "is-connected": _ctx.isConnected,
      "is-loading": _ctx.isLoading,
      error: _ctx.error
    }, null, 8, ["is-connected", "is-loading", "error"]),
    (_ctx.mintResult)
      ? (_openBlock(), _createBlock(_component_NotifySuccess, {
          key: 3,
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _hoisted_24,
            (!_ctx.newNFT)
              ? (_openBlock(), _createBlock(_component_LoadingIcon, {
                  key: 0,
                  align: "left",
                  class: "mt-5"
                }, {
                  default: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createVNode(_component_ExplorerLink, {
                    "tx-id": _ctx.mintResult.txId
                  }, null, 8, ["tx-id"]),
                  _createVNode(_component_NFTViewCard, {
                    n: _ctx.newNFT,
                    class: "text-black"
                  }, null, 8, ["n"])
                ]))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isModalVisible('tooltipArweave'))
      ? (_openBlock(), _createBlock(_component_ModalWindow, {
          key: 4,
          title: "What's this URI?",
          onHideModal: _cache[9] || (_cache[9] = ($event: any) => (_ctx.hideModal('tooltipArweave')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ContentTooltipArweave)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}